import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    padding: 0;
    margin: 0;
    outline: none;
    list-style: none;
    font-family: inherit;
    color: inherit;
    -webkit-tap-highlight-color: rgba(0,0,0,0);

    ::-webkit-scrollbar-track {
      background: inherit;
      border: none;
    }
    ::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.palette.white.A1};
      border-radius: 8px;
    }
  }

  a {
    text-decoration: none;
  }

  input {
    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    :-webkit-autofill,
    :-webkit-autofill:hover, 
    :-webkit-autofill:focus {
      box-shadow: 0 0 0 30px ${({ theme }) => theme.palette.background.default} inset;
      -webkit-text-fill-color: ${({ theme }) => theme.palette.text.primary};
    }
  }

  *::selection {
    background-color: ${({ theme }) => theme.palette.primary[400]};
    color: ${({ theme }) => theme.palette.primary.contrastText};
  }

  html {
    font-family: ${({ theme }) => theme.font.family.main};
    font-size:  ${({ theme }) => theme.font.size.md};
    font-weight: ${({ theme }) => theme.font.weight.md};
    color: ${({ theme }) => theme.palette.text.primary};
    background-color: ${({ theme }) => theme.palette.background.default};
  }

  html,
  body,
  #root {
    min-height: 100%;
    height: 1px;
  }

  mark {
    background-color: ${({ theme }) => theme.palette.mark.background};
    border-radius: 2px;
  }

  #root {
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
  }

  .cursor-pointer {
    cursor: pointer;
  }
`;
